var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.1875,
    width: 42.2222,
    height: 37,
    rx: 3.3,
    fill: "url(#paint0_linear_198_67014)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28784 26.9375H13.5453C14.8423 26.9375 15.8853 25.9188 15.8853 24.6728V12.1581C15.8853 10.912 14.8423 9.89338 13.5453 9.89338H1.28784V8.89338H13.5453C15.3915 8.89338 16.8882 10.355 16.8882 12.1581V24.6728C16.8882 26.4758 15.3915 27.9375 13.5453 27.9375H1.28784V26.9375ZM12.5424 27.9375V36.9375H11.5395V27.9375H12.5424ZM31.5971 27.9375V36.9375H30.5942V27.9375H31.5971ZM12.5424 0.1875L12.5422 8.8925L13.5453 8.89338C15.3915 8.89338 16.8882 10.355 16.8882 12.1581L16.8876 12.1875H27.474L27.4741 12.1581C27.4741 10.4282 28.8519 9.01254 30.5942 8.90052L30.5942 0.1875H31.5971L31.5969 8.8925L43.6317 8.89338V9.89338H30.8171C29.5201 9.89338 28.477 10.912 28.477 12.1581L28.4769 17.1875H43.6317V18.1875H28.4769L28.477 24.6728C28.477 25.8669 29.435 26.8522 30.6563 26.9323L30.8171 26.9375H43.6317V27.9375H30.8171C28.9708 27.9375 27.4741 26.4758 27.4741 24.6728L27.474 23.1875H16.8876L16.8882 24.6728C16.8882 26.4758 15.3915 27.9375 13.5453 27.9375H1.28784V26.9375H13.5453C14.8423 26.9375 15.8853 25.9188 15.8853 24.6728L15.8848 18.1875H1.28784V17.1875H15.8848L15.8853 12.1581C15.8853 10.912 14.8423 9.89338 13.5453 9.89338H1.28784V8.89338L11.5393 8.8925L11.5395 0.1875H12.5424ZM27.474 13.1875H16.8876V22.1875H27.474V13.1875Z",
    fill: "url(#paint1_linear_198_67014)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_67014",
    x1: -15.8889,
    y1: 19.8402,
    x2: 17.1282,
    y2: 56.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCA6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA8106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_67014",
    x1: 22.4597,
    y1: 0.1875,
    x2: 22.4597,
    y2: 36.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.8adf61cf7efea7812fdc3c95694a1b9f.svg";
export { ForwardRef as ReactComponent };